import {getEventObj} from "../atBrowserUtils"

export default class CommentsController{
    constructor(dateFormat)
    {
        this.dateFormat = dateFormat;
        this.enabled = true;
        this.commentsShown = false;

        let self = this;
        this.viewCommentsListeners = [];
        descriptionPopup.setAfterShowHandler(function() { self.fireViewComments(); });
        descriptionPopup.setAfterHideHandler(function() { self.fireCloseComments(); });

        this.addViewCommentsListener({
            onViewComments() { self.commentsShown = true; },
            onCloseComments() { self.commentsShown = false; }
        });

        let prevHandler = document.onmousedown;
        document.onmousedown = function(evt)
        {
            if (prevHandler)
                prevHandler.call(this, evt);

            if (self.commentsShown && !isBusyState())
            {
                evt = getEventObj(evt);
                let targetElm = evt.target || evt.srcElement;

                while (targetElm)
                {
                    if (targetElm.id == descriptionPopup.getDivId())
                        break;

                    targetElm = targetElm.parentNode;
                }
            }
        };
    }

    addViewCommentsListener(listener)
    {
        this.viewCommentsListeners.push(listener);
    }

    fireViewComments()
    {
        for (let i = 0; i < this.viewCommentsListeners.length; i++)
            this.viewCommentsListeners[i].onViewComments();
    }

    fireCloseComments()
    {
        for (let i = 0; i < this.viewCommentsListeners.length; i++)
            this.viewCommentsListeners[i].onCloseComments();
    }

    registerCommentsEl(elm, cell)
    {
        let self = this;
        let commentsParameters = this.getCommentsParameters(cell);

        elm.onmousedown = function(evt)
        {
            if (self.enabled)
            {
                evt = getEventObj(evt);
                evt.cancelBubble = true;
            }
        };

        elm.onclick = function()
        {
            if (self.enabled)
            {
                showViewCommentsPopup(commentsParameters);
                self.fireViewComments();
            }
        };
    }

    getCommentsParameters(taskDayCell)
    {
        let userId = taskDayCell.getRow().getParentRow().getHeaderCell().getValue().id;
        let taskId = taskDayCell.getRow().getHeaderCell().getValue().id;
        let commentsDate = taskDayCell.getRow().getTable().getDatesRow().getCell(taskDayCell.getColIdx()).getValue().date;
        let commentsDateStr = this.dateFormat.formatDate(commentsDate);
        return new ViewCommentsParameters(taskId, userId, commentsDateStr)
    }

    enableComments(enable)
    {
        this.enabled = enable;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/CommentsController.js